import { render, staticRenderFns } from "./OtherPayout.vue?vue&type=template&id=4e96d78a&"
import script from "./OtherPayout.vue?vue&type=script&lang=ts&"
export * from "./OtherPayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports